module.exports = {"150624100":"乌兰镇","150624101":"棋盘井镇","150624102":"蒙西镇","150624103":"木凯淖尔镇","150624200":"苏米图苏木乡","150624201":"阿尔巴斯苏木乡","150624403":"蒙西工业园区","150624404":"棋盘井工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/150624.json
// module id = 395
// module chunks = 0